import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Fade, makeStyles } from '@material-ui/core';
import AbsenceSet from './absenceSet';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
  },
  set: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    marginBottom: spacing(4),
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}));

const AbsenceSets = ({
  translations,
  sets = [],
  canViewAbsenceReport,
  canAccessUserProfileCheck,
  onEditSet,
  onDuplicateSet,
  onDeleteSet,
  onGetSetUsers,
  onRemoveSetUsers,
  onAddAbsence,
  onEditAbsence,
  onEditAbsenceTemplate = undefined,
  onDeleteAbsence,
  onGetAbsenceUsers,
  onRemoveAbsenceUsers,
  onAddExtension,
  onEditExtension,
  onDeleteExtension,
  onGetExtensionUsers,
  onRemoveExtensionUsers,
  onAddHoliday,
  onEditHoliday,
  onDeleteHoliday,
  onGoToProfilePage,
  onGoToAbsenceReport,
  onAddSetUsers,
  onAddAbsenceUsers,
  onAddExtensionUsers,
}) => {
  const classes = useStyles();
  const isExpanded = sets?.length === 1;

  return (
    <TransitionGroup className={classes.root}>
      {sets.map(set => (
        <Fade
          key={`absence_set_${set.id}`}
          className={classes.set}
          in
          unmountOnExit
        >
          <div>
            <AbsenceSet
              translations={translations}
              set={set}
              isAutomaticallyExpanded={isExpanded}
              canViewAbsenceReport={canViewAbsenceReport}
              onEditSet={onEditSet}
              onDeleteSet={onDeleteSet}
              onDuplicateSet={onDuplicateSet}
              onGetSetUsers={onGetSetUsers(set.id)}
              onRemoveSetUsers={onRemoveSetUsers(set)}
              onAddAbsence={onAddAbsence(set)()}
              onEditAbsence={onEditAbsence(set)}
              onEditAbsenceTemplate={onEditAbsenceTemplate}
              onDeleteAbsence={onDeleteAbsence}
              onGetAbsenceUsers={onGetAbsenceUsers}
              onRemoveAbsenceUsers={onRemoveAbsenceUsers()}
              onAddExtension={onAddExtension}
              onEditExtension={onEditExtension}
              onDeleteExtension={onDeleteExtension}
              onGetExtensionUsers={onGetExtensionUsers}
              onRemoveExtensionUsers={onRemoveExtensionUsers}
              onAddHoliday={onAddHoliday(set)}
              onEditHoliday={onEditHoliday}
              onDeleteHoliday={onDeleteHoliday}
              onGoToProfilePage={onGoToProfilePage}
              onGoToAbsenceReport={onGoToAbsenceReport}
              canAccessUserProfileCheck={canAccessUserProfileCheck}
              onAddSetUsers={onAddSetUsers}
              onAddAbsenceUsers={onAddAbsenceUsers}
              onAddExtensionUsers={onAddExtensionUsers}
            />
          </div>
        </Fade>
      ))}
    </TransitionGroup>
  );
};

AbsenceSets.propTypes = {
  translations: PropTypes.object.isRequired,
  sets: PropTypes.arrayOf(PropTypes.object),
  canViewAbsenceReport: PropTypes.bool.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onEditSet: PropTypes.func.isRequired,
  onDuplicateSet: PropTypes.func.isRequired,
  onDeleteSet: PropTypes.func.isRequired,
  onGetSetUsers: PropTypes.func.isRequired,
  onRemoveSetUsers: PropTypes.func.isRequired,
  onAddAbsence: PropTypes.func.isRequired,
  onEditAbsence: PropTypes.func.isRequired,
  onEditAbsenceTemplate: PropTypes.func,
  onDeleteAbsence: PropTypes.func.isRequired,
  onGetAbsenceUsers: PropTypes.func.isRequired,
  onRemoveAbsenceUsers: PropTypes.func.isRequired,
  onAddExtension: PropTypes.func.isRequired,
  onEditExtension: PropTypes.func.isRequired,
  onDeleteExtension: PropTypes.func.isRequired,
  onGetExtensionUsers: PropTypes.func.isRequired,
  onRemoveExtensionUsers: PropTypes.func.isRequired,
  onAddHoliday: PropTypes.func.isRequired,
  onEditHoliday: PropTypes.func.isRequired,
  onDeleteHoliday: PropTypes.func.isRequired,
  onGoToProfilePage: PropTypes.func.isRequired,
  onGoToAbsenceReport: PropTypes.func.isRequired,
  onAddSetUsers: PropTypes.func.isRequired,
  onAddAbsenceUsers: PropTypes.func.isRequired,
  onAddExtensionUsers: PropTypes.func.isRequired,
};

export default AbsenceSets;
